export default __webpack_public_path__ + "static/media/R5C_8064.2d649fa4.jpg";